import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function animateTextSplit(section, line, textLines, buttons) {

  // Inidividual tweens
  // Animated lines of text
  let textLinesTween = textLines ? gsap.to(textLines, {
    duration: 0.8,
    y: 0,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "none",
      from: "start",
    },
  }) : null;

  // Horizontal red line 
  let lineTween = line ? gsap.to(line, {
    width: "100%",
    duration: 1,
    ease: "power1.out",
  }) : null;

  // Buttons div
  let buttonsTween = buttons ? gsap.to(buttons, {
    x: 0,
    opacity: 1,
    duration: 0.25,
  }) : null;

  // Timeline
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 90%",
    },
  });

  tl
    .addLabel("textSplitStart")
    .add(lineTween, "textSplitStart+=0.4")
    .add(textLinesTween, "textSplitStart")
    .add(buttonsTween, "-=0.5");
}
